<ng-container *ngIf="value">
  {{ format | interpolate: value }}
</ng-container>
